/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {PrepareSparkWalletUpgradeRequest} from '@cash-web/protos/squareup/cash/cashliteorchestrator/api/v1beta1/orchestrator.pb'
import {PrepareSparkWalletUpgradeResponse} from '@cash-web/protos/squareup/cash/cashliteorchestrator/api/v1beta1/orchestrator.pb'


export const prepareSparkWalletUpgrade = (request: PrepareSparkWalletUpgradeRequest, options?: CashRequestOptions) => post<PrepareSparkWalletUpgradeRequest, PrepareSparkWalletUpgradeResponse>("/2.0/cash/prepare-spark-wallet-upgrade", request, {...options, rejectOnError: true })